import { applyFeatureStates, copyAllFeatureState } from '../features';
class StyleSwitcher {
    constructor( mapSearch, options = {} ) {
        this.options = Object.assign( {}, StyleSwitcher.defaults(), options );
        this.mapSearch = mapSearch;
    }

    onAdd( map ) {
        this.map = map;

        this.container = document.createElement( 'div' );
        this.container.className = [ ...this.options.containerClasses, ...StyleSwitcher.defaults().containerClasses ].join( ' ' );

        this.btn = document.createElement( 'button' );
        this.btn.setAttribute( 'type', 'button' );
        this.btn.className = [ ...this.options.btnClasses, ...StyleSwitcher.defaults().btnClasses ].join( ' ' );
        this.btn.innerHTML = `<span class="mapboxgl-ctrl-text">${this.options.altStyle.btnHTML}</span><span class="mapboxgl-ctrl-icon ${this.options.altStyle.id}" aria-hidden="true"></span>`;
        this.btn.title = this.options.altStyle.btnHTML;
        this.btn.dataset.targetMode = this.options.altStyle.id;

        this.container.appendChild( this.btn );

        this.btn.addEventListener( 'click', this.onClick.bind( this ) );

        return this.container;
    }

    sync( targetMode ) {
        this.updateState( targetMode );
    }

    updateState( mode ) {
        if ( mode === this.options.defaultStyle.id ) {
            this.btn.innerHTML = `<span class="mapboxgl-ctrl-text">${this.options.altStyle.btnHTML}</span><span class="mapboxgl-ctrl-icon ${this.options.altStyle.id}" aria-hidden="true"></span>`;
            this.btn.dataset.targetMode = this.options.altStyle.id;
            this.btn.title = this.options.altStyle.btnHTML;
        }

        if ( mode === this.options.altStyle.id ) {
            this.btn.innerHTML = `<span class="mapboxgl-ctrl-text">${this.options.defaultStyle.btnHTML}</span><span class="mapboxgl-ctrl-icon ${this.options.defaultStyle.id}" aria-hidden="true"></span>`;
            this.btn.dataset.targetMode = this.options.defaultStyle.id;
            this.btn.title = this.options.defaultStyle.btnHTML;
        }
    }

    async onClick() {
        let nextModesStyleURL = this.options.altStyle.url;
        let nextModeID = this.options.altStyle.id;

        this.btn.disabled = true;

        if ( this.btn.dataset.targetMode !== this.options.altStyle.id ) {
            nextModeID = this.options.defaultStyle.id;
            nextModesStyleURL = this.options.defaultStyle.url;
        }

        this.updateState( nextModeID );

        const newStyleResponse = await window.http( nextModesStyleURL );

        const newStyleJSON = await newStyleResponse.json();

        let newStyle = newStyleJSON;

        if ( typeof this.options.beforeSetStyle === 'function' ) {
            newStyle = this.options.beforeSetStyle( this.mapSearch, newStyle );
        }

        const featureStateBeforeStyleChange = copyAllFeatureState( this.map );

        this.map.setStyle( newStyle, {
            diff: false,
        } );

        if ( typeof this.options.afterSetStyle === 'function' ) {
            this.map.once( 'idle', () => {
                if ( this.map.isStyleLoaded() ) {
                    applyFeatureStates( this.map, featureStateBeforeStyleChange );
                    this.options.afterSetStyle( this.mapSearch );
                }
            } );
        }

        this.map.once( 'idle', () => {
            this.btn.disabled = false;
        } );

        this.sync( nextModeID );
    }

    onRemove() {
        this.map = undefined;
    }

    static defaults() {
        return {
            beforeSetStyle: null,
            afterSetStyle: null,
            defaultStyle: {
                id: '',
                url: '',
                btnHTML: '',
            },
            altStyle: {
                id: '',
                url: '',
                btnHTML: '',
            },
            containerClasses: [
                'mapboxgl-ctrl',
                'mapboxgl-ctrl-group',
                'styleswitcher__container',
            ],
            btnClasses: [
                'twc__map-search-style-switcher',
                'twc__map-search-item',
            ],
        };
    }
}

export default StyleSwitcher;
